import PropTypes from 'prop-types';
import { css, etiColors } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { price as priceUtil } from '@eti/utils';

const containerStyles = css`
  border: 1px solid ${etiColors.grayScale[6]};
  border-radius: 0.1875rem;
  font-size: 0.75rem;
`;

const priceBoxStyles = css`
  background: ${etiColors.grayScale[2]};
  border-bottom: 1px solid ${etiColors.grayScale[6]};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px;

  &:last-of-type {
    border-bottom: none;
    font-size: 0.875rem;
    font-weight: 400;

    & span:last-of-type {
      font-weight: 700;
    }
  }
`;

const ReviewModalCartInformation = ({ discountAmount, totalPrice }) => {
  const { t } = useTranslation();

  return (
    <div className={containerStyles}>
      {discountAmount && discountAmount < 0 ? (
        <div
          className={priceBoxStyles}
          data-testid="travelerDetails-reviewModal-CartInformation-priceBox"
        >
          <span>{t('Payment.Cart.Discount.Label')}</span>
          <span>{priceUtil.formatPrice(discountAmount)}</span>
        </div>
      ) : null}
      <div
        className={priceBoxStyles}
        data-testid="travelerDetails-reviewModal-CartInformation-priceBox"
      >
        <span>{t('Cart.TotalInclTaxFees')}</span>
        <span>{priceUtil.formatPrice(totalPrice)}</span>
      </div>
    </div>
  );
};

ReviewModalCartInformation.propTypes = {
  discountAmount: PropTypes.number,
  totalPrice: PropTypes.number,
};

export default ReviewModalCartInformation;
